<template>
  <div class="cursor-default">
    <div class="flex flex-wrap">
      <div
        v-for="(item,i) of tabs"
        :key="i"
        @click="select(item)"
        :class="isGrow ?  'flex-grow' : 'text-center'"
      >
        <div
          class="flex items-center p-1 px-3 text-center w-full"
          style="font-size:12px"
          :class="[applyActiveStyle(item)]"
        >
          <div>
            <slot :name="item"></slot>
          </div>
          <span class="w-full">{{item}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "VTabs",
  data() {
    return {
      tab: ""
    };
  },
  props: {
    value: { default: "" },
    tabs: { default: [] },
    isGrow: { default: false }
  },
  mounted() {
    this.select(this.tabs[0]);
  },
  computed: {},
  methods: {
    select(tab) {
      this.tab = tab;
      this.$emit("change", tab);
    },
    applyActiveStyle(item) {
      return this.tab == item
        ? "bg-tabs-selected  text-white"
        : "bg-tabs text-gray-500 ";
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
